import React, { useState } from "react";
import PurchaseInformation from "../components/PurchaseInformation";
import Layout from "../components/Layout";
import PersonalDetails from "../components/PersonalDetails";
import SuccessfullSubmit from "../components/SuccessfullSubmit";

const MainPage = () => {
  const [purchaseInformation, setPurchaseInformation] = useState({
    receipt: null,
    receiptDate: null
  });

  const [personalDetails, setPersonalDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    consentChecked: false,
    futurePromotions: false
  });

  const [steps, setSteps] = useState([
    {
      id: 1,
      name: "Purchase information",
      isActive: true,
      isCompleted: false
    },
    {
      id: 2,
      name: "Personal details",
      isActive: false,
      isCompleted: false
    }
  ]);

  const goBack = () => {
    const currentStep = steps.find((item) => item.isActive);
    if (currentStep.id === 1) return;
    setSteps((prevState) =>
      prevState.map((item) => {
        if (item.id === currentStep.id) {
          return {
            ...item,
            isActive: false
          };
        }
        if (item.id === currentStep.id - 1) {
          return {
            ...item,
            isActive: true,
            isCompleted: false
          };
        }

        return item;
      })
    );
  };

  const goNext = () => {
    const currentStep = steps.find((item) => item.isActive);

    setSteps((prevState) =>
      prevState.map((item) => {
        if (item.id === currentStep.id) {
          return {
            ...item,
            isActive: false,
            isCompleted: true
          };
        }
        if (item.id === currentStep.id + 1) {
          return {
            ...item,
            isActive: true,
            isCompleted: false
          };
        }

        return item;
      })
    );
  };
  const activeStep = steps.find((item) => item.isActive);

  return (
    <Layout>
      <div className="w-full min-h-[550px] flex flex-col justify-center max-w-[95%] bg-white rounded-[12px] shadow mx-auto px-6 sm:px-10 md:px-[50px] lg:px-[95px] py-[24px] md:py-[36px] flex flex-col md:items-center mt-2">
        {activeStep && (
          <div className="flex items-center w-full mb-14">
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={goBack}
              className={
                "mr-auto cursor-pointer relative " +
                (activeStep && activeStep.id > 1 ? "opacity-1" : "opacity-0")
              }
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.80812 0.334735C9.25444 0.781049 9.25444 1.50467 8.80812 1.95098L2.7591 8L8.80812 14.049C9.25444 14.4953 9.25444 15.219 8.80812 15.6653C8.36181 16.1116 7.63819 16.1116 7.19188 15.6653L0.334735 8.80812C-0.111578 8.36181 -0.111578 7.63819 0.334735 7.19188L7.19188 0.334735C7.63819 -0.111578 8.36181 -0.111578 8.80812 0.334735Z"
                fill="#215732"
              />
            </svg>

            <div className="flex flex-col md:flex-row md:items-center md:mx-auto space-y-8 md:space-y-0 ">
              {steps.map((step, i) => (
                <div className="flex items-center" key={step.id}>
                  <div
                    className={
                      "w-[20px] h-[20px] rounded-full border border-[#215732] flex items-center justify-center " +
                      (step.isActive || step.isCompleted
                        ? "opacity-1 bg-[#215732]"
                        : "border-opacity-50 bg-transparent")
                    }
                  >
                    <div className="flex flex-col items-center justify-center">
                      <p
                        className={
                          "flex items-center justify-center mt-6 text-xs font-bold h-[20px] " +
                          (step.isActive || step.isCompleted
                            ? "text-white"
                            : "text-[#215732] opacity-50")
                        }
                      >
                        {step.isCompleted ? (
                          <svg
                            width="10"
                            height="8"
                            viewBox="0 0 8 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="my-2"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.86983 0.135181C8.04339 0.315423 8.04339 0.607653 7.86983 0.787895L2.98094 5.86482C2.80737 6.04506 2.52596 6.04506 2.3524 5.86482L0.130175 3.55713C-0.0433916 3.37688 -0.0433916 3.08465 0.130175 2.90441C0.303741 2.72417 0.585148 2.72417 0.758714 2.90441L2.66667 4.88575L7.24129 0.135181C7.41485 -0.0450605 7.69626 -0.0450605 7.86983 0.135181Z"
                              fill="white"
                            />
                          </svg>
                        ) : (
                          step.id
                        )}
                      </p>
                      <p
                        className={
                          "text-xs text-[#3e3e3e] w-[140px] mt-2 font-bold " +
                          (step.isActive || step.isCompleted
                            ? "opacity-1 "
                            : "opacity-50 ") +
                          (step.id === 2 ? "ml-28 md:ml-12" : "ml-28 md:ml-6")
                        }
                      >
                        {step.name}
                      </p>
                    </div>
                  </div>
                  {step.id !== 2 && (
                    <div
                      className={
                        "border-b-[1px] border-[#08792A] w-[150px] " +
                        ((activeStep.id === 1 && i < 2) ||
                        (activeStep.id === 2 && i === 1)
                          ? "border-opacity-50"
                          : "border-opacity-1")
                      }
                    ></div>
                  )}
                </div>
              ))}
            </div>

            <div className="ml-auto"></div>
          </div>
        )}
        {activeStep && activeStep.id === 1 && (
          <PurchaseInformation
            purchaseInformation={purchaseInformation}
            setPurchaseInformation={setPurchaseInformation}
            goNext={goNext}
          />
        )}
        {activeStep && activeStep.id === 2 && (
          <PersonalDetails
            personalDetails={personalDetails}
            purchaseInformation={purchaseInformation}
            setPersonalDetails={setPersonalDetails}
            goNext={goNext}
          />
        )}

        {!activeStep && (
          <SuccessfullSubmit
            title="Thanks for entering our promotion!"
            subtitle="We'll be in touch."
          />
        )}
      </div>
    </Layout>
  );
};

export default MainPage;
